export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            了解吃瓜在线背后的故事与使命
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-chat-3-line text-3xl text-primary-500"></i>
            </div>
            <div className="flex-1">
              <p className="text-foreground-600 leading-relaxed mb-4">
                吃瓜在线诞生于网络娱乐文化蓬勃发展的时代，致力于为广大网友打造一个便捷、全面、可靠的娱乐资讯聚合入口。平台整合了
                <strong className="text-foreground-900">51吃瓜在线</strong>、<strong className="text-foreground-900">91吃瓜在线</strong>、<strong className="text-foreground-900">17吃瓜在线</strong>
                等多个热门吃瓜站点的直达入口，让用户无需在多个平台之间反复切换，即可一站式浏览全网最新八卦内容。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                我们的编辑团队全天候关注娱乐圈动态，涵盖明星八卦、影视综艺、音乐时尚、网红生态、国际娱乐等30余个内容品类，每日更新资讯超过200条。无论是最新恋情曝光、综艺收视大战，还是影视作品口碑追踪、音乐榜单变动，吃瓜在线都会第一时间为您呈现。
              </p>
              <p className="text-foreground-600 leading-relaxed">
                安全、稳定、快速是吃瓜在线始终坚持的服务准则。我们采用先进的加密传输技术保障用户隐私与浏览安全，并持续维护各关联平台的最新地址，确保用户无论何时何地都能畅通无阻地访问心仪的吃瓜内容。吃瓜在线——让每一次浏览都成为愉快的发现之旅。
              </p>
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-black text-primary-500 font-heading">2021</div>
              <div className="text-xs text-foreground-400 mt-1">平台创立年份</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-black text-primary-500 font-heading">100万+</div>
              <div className="text-xs text-foreground-400 mt-1">日活跃用户</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-black text-primary-500 font-heading">50+</div>
              <div className="text-xs text-foreground-400 mt-1">聚合平台数</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}